import { unansweredOffers, UnansweredOffer } from "@/mocks/rop";

function formatMoney(value: number): string {
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(value);
}

interface UnansweredOffersModalProps {
  onClose: () => void;
}

export default function UnansweredOffersModal({ onClose }: UnansweredOffersModalProps) {
  return (
    <div className="fixed inset-0 bg-foreground-950/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg border border-[#D5CA8A] w-full max-w-3xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 bg-[#FEF3C7] border-b border-[#D5CA8A] rounded-t-lg">
          <div className="flex items-center gap-2">
            <i className="ri-mail-unread-line text-[#D97706]"></i>
            <span className="text-[12px] font-semibold text-[#2D2D2D]">КП без ответа ({unansweredOffers.length})</span>
            <span className="text-[10px] text-[#D97706] ml-2">Сумма: {formatMoney(unansweredOffers.reduce((s, o) => s + o.amount, 0))}</span>
          </div>
          <button onClick={onClose} className="w-6 h-6 flex items-center justify-center rounded hover:bg-[#E8DB6C] cursor-pointer">
            <i className="ri-close-line text-[#666666]"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <div className="space-y-2">
            <div className="flex items-center text-[10px] text-[#666666] px-2 py-1 bg-[#FDF2B5] rounded">
              <span className="flex-1">Клиент</span>
              <span className="w-[90px] text-right">Сумма</span>
              <span className="w-[90px] text-right">Отправлено</span>
              <span className="w-[70px] text-right">Дней</span>
              <span className="w-[90px] text-right">Менеджер</span>
            </div>
            {unansweredOffers.map((o: UnansweredOffer) => (
              <div key={o.id} className="flex items-center text-[10px] px-2 py-2 border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/20 rounded transition-colors">
                <span className="flex-1 text-[#2D2D2D] truncate">{o.client.replace("ООО ", "").replace("АО ", "")}</span>
                <span className="w-[90px] text-right text-[#2D2D2D] font-medium">{formatMoney(o.amount)}</span>
                <span className="w-[90px] text-right text-[#666666]">{o.sentDate}</span>
                <span className={`w-[70px] text-right font-medium ${o.daysWithoutAnswer > 14 ? "text-[#DC2626]" : "text-[#D97706]"}`}>{o.daysWithoutAnswer} дн.</span>
                <span className="w-[90px] text-right text-[#666666]">{o.manager}</span>
              </div>
            ))}
          </div>
          <div className="mt-4 p-3 bg-[#FEF3C7] rounded-lg">
            <p className="text-[11px] font-semibold text-[#2D2D2D] mb-1">Рекомендации AI</p>
            <p className="text-[10px] text-[#666666]">
              КП №КП-046 (ООО Гардинная Мануфактура, 20 дней) и КП №КП-047 (ООО Мебельный Текстиль, 26 дней) требуют немедленного звонка.
              Все 5 КП просрочены более 7 дней — риск потери {formatMoney(unansweredOffers.reduce((s, o) => s + o.amount, 0))}.
              Рекомендуется: правило «КП без ответа 3 дня → автозадача Позвонить клиенту».
            </p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-[#D5CA8A] bg-[#FFF9E6] rounded-b-lg">
          <button onClick={onClose} className="px-3 py-1.5 rounded text-[11px] text-[#666666] hover:bg-[#FDF2B5] cursor-pointer transition-colors whitespace-nowrap">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}